import { useState } from 'react';

interface OrganizationLogoProps {
  logoUrl?: string | null;
  organizationName?: string;
  variant: 'header' | 'sidebar';
}

interface LogoImageProps extends OrganizationLogoProps {
  logoUrl: string | null;
}

const customLogoClasses = {
  header: 'max-h-8 max-w-[80px] sm:max-w-[100px] object-contain',
  sidebar: 'max-h-10 max-w-[120px] object-contain',
};

const defaultLogoClasses = {
  header: 'h-5 w-auto object-contain',
  sidebar: 'h-6 w-auto object-contain',
};

function LogoImage({
  logoUrl,
  organizationName,
  variant,
}: LogoImageProps) {
  const [failed, setFailed] = useState(false);
  const showDefault = !logoUrl || failed;

  return (
    <img
      src={showDefault ? '/logos/h3ight.svg' : logoUrl}
      alt={showDefault ? 'H3ight' : organizationName || 'Company logo'}
      className={
        showDefault ? defaultLogoClasses[variant] : customLogoClasses[variant]
      }
      onError={showDefault ? undefined : () => setFailed(true)}
    />
  );
}

export function OrganizationLogo({
  logoUrl = null,
  organizationName,
  variant,
}: OrganizationLogoProps) {
  return (
    <LogoImage
      key={logoUrl || 'default'}
      logoUrl={logoUrl}
      organizationName={organizationName}
      variant={variant}
    />
  );
}
